import { AccountForm } from 'components/account/AccountSignupForm';
import firebase from 'firebase';
import Database from './Database';

const provider = new firebase.auth.GoogleAuthProvider();

export function googleSignIn(): Promise<firebase.auth.UserCredential> {
  return Database.auth().signInWithPopup(provider);
}

export async function signIn(): Promise<firebase.auth.UserCredential | null> {
  const credentials = await googleSignIn();

  if (credentials.user) {
    const account = (
      await Database.get().ref(`/accounts/${credentials.user.uid}`).once('value')
    ).val();

    if (account) {
      return credentials;
    }

    // The user hasn't signed up, so just signout immediately
    signOut();
  }

  return null;
}

export function signOut() {
  return Database.auth().signOut();
}

export async function isUserSignedUp(uid: string): Promise<boolean> {
  const account = (await Database.get().ref(`/accounts/${uid}`).once('value')).val();
  return Boolean(account);
}

export async function createAccount(account: AccountForm, user: firebase.User): Promise<boolean> {
  const formattedAccount: AccountForm = {
    ...account,
    school: {
      ...account.school,
      // Firebase doesn't accept undefined, so we need to pass an empty string if it's blank
      zip: account.school.zip ?? ('' as never),
    },
  };

  try {
    await Database.get().ref(`/accounts/${user.uid}`).set(formattedAccount);

    return true;
  } catch (error) {
    console.warn('Error saving account data', error);

    return false;
  }
}
